import MainText from './MainText';

export default MainText;
